import React from "react";

import { cn } from "../../utils/utils";

const Button = (props) => {
  const { children, className, onClick, disabled, tab, type } = props;

  return (
    <button
      tabIndex={tab}
      onClick={onClick}
      disabled={disabled}
      type={type}
      className={cn(
        "p-1 md:py-2 md:px-4 bg-primary-20 rounded-lg disabled:bg-slate-200 disabled:pointer-events-none ",
        className,
      )}
    >
      {children}
    </button>
  );
};

export default Button;
